document.addEventListener('DOMContentLoaded', function () {
  // Toggle empty state on search input
  var searchInputs = document.querySelectorAll('.search-modal__form .search__input');
  searchInputs.forEach(function (input) {
    var form = input.closest('form');
    var emptyState = form && form.querySelector('[data-search-empty-state]');
    if (!emptyState) return;
    function toggleEmptyState() {
      emptyState.classList.toggle('is-visible', input.value.trim() === '');
    }
    input.addEventListener('input', toggleEmptyState);
    var resetBtn = form && form.querySelector('.reset__button');
    if (resetBtn) resetBtn.addEventListener('click', function () { setTimeout(toggleEmptyState, 0); });
    // Show when modal opens (details open event)
    var details = input.closest('details');
    if (details) details.addEventListener('toggle', function () { if (details.open) toggleEmptyState(); });
    toggleEmptyState();
  });

  const staticEls = document.querySelectorAll('.header__search-bar-text-static');
  const dynamicEls = document.querySelectorAll('.header__search-bar-text-dynamic');
  if (!staticEls || staticEls.length === 0 || !dynamicEls || dynamicEls.length === 0) return;

  // Prevent double-init if the snippet gets rendered more than once.
  if (window.__headerSearchRotatorInitialized) return;
  window.__headerSearchRotatorInitialized = true;

  // This typing/deleting effect runs on an indefinite loop (a fresh setTimeout is scheduled
  // every 40-80ms, forever) purely for decorative placeholder text - it's not needed for
  // search to function. Starting it immediately on DOMContentLoaded makes it compete with
  // critical parsing/rendering work during the busiest part of page load, which shows up as
  // "Script Evaluation" time against this file in Total Blocking Time measurements. Deferring
  // the *start* to the browser's idle time (falling back to a short timeout on browsers
  // without requestIdleCallback, e.g. Safari) pushes that cost out of the critical window
  // without changing what the effect looks like or how long it's been running by the time a
  // user notices it - it just begins a beat later.
  const startRotator = () => initRotator();
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(startRotator, { timeout: 2000 });
  } else {
    setTimeout(startRotator, 200);
  }
  return;

  function initRotator() {
    // Use NBSP so the space between "Search For" and the typed word never collapses.
    const prefixText = 'Search For ';

    const rotatorEl = document.querySelector('[data-header-search-texts]');
    const rotationRaw = rotatorEl ? rotatorEl.dataset.headerSearchTexts : 'Search';
    const list = (rotationRaw || '')
      .split(',')
      .map((t) => t.trim())
      .filter(Boolean);

    const fallback = 'Search';
    const texts = list.length ? list : [fallback];

    let wordIndex = 0;
    let prefixIndex = 0;
    let wordIndexInChars = 0;

    const typingSpeedMs = 80; // per character typing
    const deletingSpeedMs = 40; // per character deleting
    const pauseAfterTypedMs = 1200; // pause after full word typed
    const pauseAfterDeletedMs = 400; // pause after word deleted / prefix deleted
    const maxCycles = 3; // stop after this many full passes through the word list

    const render = () => {
      const currentWord = texts[wordIndex] || '';
      const visiblePrefix = prefixText.substring(0, prefixIndex);
      const visibleWord = currentWord.substring(0, wordIndexInChars);

      staticEls.forEach((el) => {
        el.textContent = visiblePrefix;
      });
      dynamicEls.forEach((el) => {
        el.textContent = visibleWord;
      });
    };

    // This is a purely decorative loop with no natural end, so it needs an explicit stop
    // condition - otherwise it keeps rescheduling itself for as long as the page stays open.
    // `stopped` is checked by scheduleTick() before every recursive setTimeout, so every call
    // site is covered by construction rather than repeating the check at each one.
    let stopped = false;
    let cycleCount = 0;

    function stopRotator() {
      stopped = true;
    }

    // Once the user is actually using the search field, the placeholder animation serves no
    // purpose - stop immediately regardless of the cycle cap.
    searchInputs.forEach((input) => {
      input.addEventListener('focus', stopRotator, { once: true });
      input.addEventListener('click', stopRotator, { once: true });
    });

    function scheduleTick(delay) {
      if (stopped) return;
      setTimeout(tick, delay);
    }

    // State machine:
    // 1) type prefix (SEARCH FOR )
    // 2) type full word, pause
    // 3) delete ONLY the word, then type next word (prefix stays)
    // 4) after last word: delete word, then delete prefix, restart from first word
    let phase = 'prefixTyping'; // prefixTyping | wordTyping | wordDeleting | prefixDeleting

    const tick = () => {
      if (phase === 'prefixTyping') {
        prefixIndex += 1;
        if (prefixIndex >= prefixText.length) {
          prefixIndex = prefixText.length;
          phase = 'wordTyping';
          wordIndexInChars = 0;
          render();
          // No extra pause here; we want "SEARCH FOR " to flow into the word.
          scheduleTick(typingSpeedMs);
          return;
        }

        render();
        scheduleTick(typingSpeedMs);
        return;
      }

      if (phase === 'wordTyping') {
        const currentWord = texts[wordIndex] || '';
        wordIndexInChars += 1;

        if (wordIndexInChars >= currentWord.length) {
          wordIndexInChars = currentWord.length;
          render();

          if (wordIndex === texts.length - 1) {
            cycleCount += 1;
            if (cycleCount >= maxCycles) {
              // Stop right here, at the end of a typing phase: the word just rendered above
              // stays fully visible instead of the animation cutting off mid-delete/blank.
              stopped = true;
              return;
            }
          }

          phase = 'wordDeleting';
          scheduleTick(pauseAfterTypedMs);
          return;
        }

        render();
        scheduleTick(typingSpeedMs);
        return;
      }

      if (phase === 'wordDeleting') {
        wordIndexInChars -= 1;

        if (wordIndexInChars <= 0) {
          wordIndexInChars = 0;

          if (wordIndex < texts.length - 1) {
            wordIndex += 1;
            phase = 'wordTyping';
            render();
            scheduleTick(pauseAfterDeletedMs);
            return;
          }

          // Last word finished -> delete prefix, then restart.
          phase = 'prefixDeleting';
          render();
          // No extra pause here; we want immediate prefix deletion after last word.
          scheduleTick(deletingSpeedMs);
          return;
        }

        render();
        scheduleTick(deletingSpeedMs);
        return;
      }

      if (phase === 'prefixDeleting') {
        prefixIndex -= 1;

        if (prefixIndex <= 0) {
          prefixIndex = 0;
          wordIndex = 0;
          wordIndexInChars = 0;
          phase = 'prefixTyping';
          render();
          scheduleTick(pauseAfterDeletedMs);
          return;
        }

        render();
        scheduleTick(deletingSpeedMs);
        return;
      }
    };

    // Start with empty prefix+word then type "SEARCH FOR " first.
    prefixIndex = 0;
    wordIndexInChars = 0;
    phase = 'prefixTyping';
    render();
    tick();
  }
});
